import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { Fancybox } from "@fancyapps/ui";
import { Modal, Tooltip, Alert } from 'bootstrap';
import '@slightlyoff/lite-vimeo';
// import scrollSpy from '@sidsbrmnn/scrollspy';
import '../../../../../node_modules/lite-youtube-embed/src/lite-yt-embed.js';

import '../components/axios.js';
import Cookie from '../../../../dev/js/components/cookie.js';
import initPrototypes from '../components/prototypes.js';
import { getPublicUrl, detectLanguageParameter } from '../components/utils.js';
import AuthService from '../services/auth-service.js';
import ReCaptchaService from '../services/recaptcha-service.js';
import LikeService from '../services/like-service.js';

window.dataLayer = window.dataLayer || [];
window.Cookie = Cookie;
window.$ = $;
initPrototypes();

class Company {
	constructor() {
		window.authService = this.authService = new AuthService();
		this.authService.init();
		window.reCaptchaService = this.reCaptchaService = new ReCaptchaService();
		this.reCaptchaService.init(); // TODO: it can be deleted after public.js isn't used anymore
		window.likeService = this.likeService = new LikeService();

		Fancybox.bind("[data-fancybox]");

		this.page = 1;
		this.questionPage = 1;
		this.lang = detectLanguageParameter();
		this.box = document.querySelector('.company-cards .reviews');
		this.nextButton = document.getElementById('next-button');
		this.reviewScoreBox = document.querySelector('#form-review-filter h3.ti-score');
		this.reviewCountBox = document.querySelector('#form-review-filter h3 span.ti-count');
		// this.questionBox = document.querySelector('.questions .reviews-body');
		// this.tabMenu = document.querySelector('.tab-menu');
		this.filterForm = document.getElementById('form-review-filter');
		this.publicId = this.filterForm.dataset.companyId;

		this.init();
	}

	init() {
		// this.setupScrollSpy();
		// this.setupSmoothScroll();
		this.bindEvents();
		this.initOfferHandling();
		this.initProgressBar();
		this.initGaEventTracking();
		this.addCampaignParameters();

		this.formatReviews(this.box);

		const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
		const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
	}

	bindEvents() {
		document.querySelectorAll('.filter-change-ajax').forEach(element => {
			element.addEventListener('change', () => this.handleFilterChange());
		});

		this.nextButton.addEventListener('click', (event) => {
			event.preventDefault();
			this.loadNextPage();
		});

		const languageFilter = document.getElementById('language-filter');
		if (languageFilter) {
			languageFilter.addEventListener('change', () => this.handleFilterChange());
		}
	}

	initProgressBar() {
		document.querySelectorAll('.animated-progress span').forEach(element => {
			element.style.transform = 'translateX(0)';
		});
	}

	setNavigation(showNext) {
		this.nextButton.style.display = showNext ? 'block' : 'none';
	}

	getFilters() {
		const formData = new FormData(this.filterForm);
		const result = {
			star: [],
			type: [],
			verified: false,
			lang: ''
		};

		for (let [key, value] of formData.entries()) {
			if (key.includes('[ratings]')) {
				result.star.push(parseInt(value));
			} else if (key.includes('[sources]')) {
				result.type.push(value);
			} else if (key.includes('[verified]')) {
				result.verified = true;
			} else if (key.includes('[language]')) {
				result.lang = value;
			}
		}

		return result;
	}

	getReviews(callback) {
		if (this.page < 1) {
			this.page = 1;
		}

		const formData = new FormData(this.filterForm);
		formData.append('list', 'review');
		formData.append('page', this.page);

		reCaptchaService.runWithCaptcha(
			"company_review_list",
			(token, withCheckbox = false) => {
				formData.append('recaptcha_token', token);
				formData.append('recaptcha_token', withCheckbox);
				let url = `${getPublicUrl()}/api/reviews/${this.publicId}`; // this.box.dataset.url
				if (this.lang) {
					url += `/${this.lang}`;
				}
				return axios.post(url, formData)
					.then((response) => {
						console.log("company_review_list", response);
						if (this.page === 1) {
							this.box.innerHTML = '';
						}

						const tempDiv = document.createElement('div');
						tempDiv.innerHTML = response.data.html;

						const reviews = tempDiv.querySelectorAll('.reviews > *');
						const adverts = tempDiv.querySelectorAll('.reviews .full-advert');

						reviews.forEach(review => {
							this.box.appendChild(review);
							this.fadeIn(review), 100;
						});

						this.setNavigation(response.data.next_page);
						this.updateFilterStats(response, this.getFilters());
						this.formatReviews(this.box);

						if (adverts.length) {
							adverts.forEach(() => {
								(window.adsbygoogle = window.adsbygoogle || []).push({});
							});
						}

						if (callback) {
							callback();
						}
					})
					.catch((error) => {
						console.error("company_review_list", error);
						if (callback) {
							callback();
						}
					});
			}
		);
	}

	updateFilterStats(response, filter) {
		const hasFilter = this.hasActiveFilter(filter);
		const reviewCount = response.data.count;
		const reviewScore = response.data.score;

		if (reviewCount && this.reviewCountBox) {
			if (reviewCount === 0) {
				const profileReviews = document.querySelector('.hero-block .company-rating .ti-count');
				if (profileReviews) {
					this.reviewCountBox.textContent = profileReviews.textContent;
				}
			} else {
				this.reviewCountBox.textContent = reviewCount;
			}
		}

		if (reviewScore && this.reviewScoreBox) {
			if (reviewScore === 0) {
				const profileRating = document.querySelector('.hero-block .company-rating .ti-score');
				if (profileRating) {
					this.reviewScoreBox.textContent = profileRating.textContent;
				}
			} else {
				this.reviewScoreBox.textContent = reviewScore.toFixed(1);
			}
		}

		if (!hasFilter && this.reviewCountBox && this.reviewScoreBox) {
			const profileReviews = document.querySelector('.hero-block .company-rating .ti-count');
			if (profileReviews) {
				this.reviewCountBox.textContent = profileReviews.textContent;
			}

			const profileRating = document.querySelector('.hero-block .company-rating .ti-score');
			if (profileRating) {
				this.reviewScoreBox.textContent = profileRating.textContent;
			}
		}
	}

	hasActiveFilter(filter) {
		for (const key in filter) {
			if (Array.isArray(filter[key]) && filter[key].length === 0) {
				continue;
			}
			if (filter[key]) {
				return true;
			}
		}
		return false;
	}

	handleFilterChange() {
		if (!this.box || this.box.classList.contains('loading')) {
			return false;
		}

		this.page = 1;
		this.box.classList.add('loading');
		this.filterForm.classList.add('disabled');
		if (this.nextButton) {
			this.nextButton.style.display = 'none';
		}

		this.getReviews(() => {
			this.box.classList.remove('loading');
			this.filterForm.classList.remove('disabled');
		});
	}

	loadNextPage() {
		if (this.nextButton && this.nextButton.classList.contains('loading')) {
			return false;
		}

		if (this.nextButton) {
			this.nextButton.classList.add('loading');
		}

		this.page++;
		this.getReviews(() => {
			if (this.nextButton) {
				this.nextButton.classList.remove('loading');
			}
		});
	}

	formatReviews(container) {
		if (typeof container === "undefined" || !container) {
			container = document.body;
		}

		const reviewContents = container.querySelectorAll('.review-details .ti-review-content');
		reviewContents.forEach(content => {
			content.TI_format().TI_shorten({
				'showLines': 30,
				'lessText': '<i class="ri-arrow-up-s-line" aria-hidden="true"></i> ' + document.body.dataset.lessText,
				'moreText': '<i class="ri-arrow-down-s-line" aria-hidden="true"></i> ' + document.body.dataset.moreText
			});
		});
	}

	fadeIn(element, duration = 300) {
		element.style['transition-duration'] = duration+'ms';
		setTimeout(() => element.classList.add('fade-in'), 100);
	}

	/** @deprecated */
	initScrollSpy() {
		scrollSpy(document.getElementById('ti-mobile-nav'), {
			sectionSelector: '.scrollspy',
			targetSelector: '.nav-link',
			offset: 90,
			activeClass: 'active',
		});
	}

	/** @deprecated */
	initSmoothScroll() {
		document.querySelectorAll('a[href^="#scrollspy"]').forEach(anchor => {
			anchor.addEventListener('click', function (e) {
				e.preventDefault();
				const observableSection = document.getElementById(e.currentTarget.hash.replace('#', ''));
				if (observableSection) {
					window.scrollTo({ top: observableSection.offsetTop - 90, behavior: 'smooth' });
				}
			});
		});
	}

	addCampaignParameters() {
		const campaignElements = {
			'.navbar a.navbar-brand': 'header-logo',
			'.navbar a.btn-success': 'header-btn',
			'.navbar a.btn-success.d-none': 'header-btn',
			'.hero-block a.btn-visit': 'header-link',
			'.ti-contact a.ti-contact-website': 'contact-website',
			'.ti-about a': 'about',
			'.footer-content a.navbar-brand': 'footer-logo'
		};

		Object.keys(campaignElements).forEach(function (selector) {
			const element = document.querySelector(selector);
			const replacement = "utm_source=trustindex&utm_medium=company_profile_page&utm_campaign=" + campaignElements[selector];

			if (element && element.href) {
				const currentHref = element.href;
				const separator = (currentHref.includes('?') || currentHref.includes('&')) ? '&' : '?';
				element.href = currentHref + separator + replacement;
			}
		});
	}

	initGaEventTracking() {
		window.dataLayer = window.dataLayer || [];

		const clickEvents = [
			{selector: '.ti-profile .ti-company-link a.verified-url', label: 'company_click', category: 'click'},
			{selector: '.ti-profile .ti-data a.ti-company-link', label: 'company_click', category: 'click'},
			{selector: 'article .write-a-review a.write-review-url', label: 'review_write_click', category: 'click'},
			{selector: 'article .reviews .review a.btn-review-like', label: 'like', category: 'click'},
			{selector: 'article .reviews .review a.btn-review-dislike', label: 'dislike', category: 'click'},
		];

		clickEvents.forEach((item) => {
			document.querySelectorAll(item.selector).forEach(element => {
				element.addEventListener('click', (event) => {
					if (event.target.hasAttribute('href')) {
						event.preventDefault();
						window.dataLayer.push({ event: item.label });
						setTimeout(() => {
							window.location.href = event.target.href;
						}, 1000);
					} else {
						window.dataLayer.push({ event: item.label });
					}
				});
			});
		});

		// document.querySelector('article .card-filter form input#keyword-search').addEventListener('change', (event) => {
		//     window.dataLayer.push({ event: 'filter_search', value: event.target.value });
		// });
	}

	async initOfferHandling() {
		try {
			const url = `${getPublicUrl()}/api/company/offer/${this.publicId}/${this.lang}`;
			const response = await axios.post(url);

			const data = response.data;

			if (data.success && data.html && data.offer) {
				const mainWrapper = document.getElementById('primary');

				if (mainWrapper) {
					const offerHtml = document.createElement('div');
					offerHtml.innerHTML = data.html;
					mainWrapper.prepend(offerHtml);
				}
			}
		} catch (error) {
			console.error('Error fetching offer:', error);
		}

		this.initSaveClickHandler();
	}

	// displayOffer(offer) {
	//     const saleBox = document.querySelector('.sale-box');
	//     if (!saleBox) return;

	//     let saleHtml = saleBox.innerHTML;

	//     saleHtml = saleHtml
	//         .replace(/\%title\%/g, offer.title)
	//         .replace(/\%offer\%/g, offer.offer)
	//         .replace(/\%target_url\%/g, offer.targetUrl)
	//         .replace(/\%offer_id\%/g, offer.id);

	//     saleBox.innerHTML = saleHtml;
	//     saleBox.classList.remove('d-none');
	// }

	initSaveClickHandler() {
		document.addEventListener('click', (event) => {
			if (event.target.id === 'saveClick') {
				this.handleSaveClick(event.target);
			}
		});
	}

	async handleSaveClick(element) {
		const offerId = element.dataset.offerId;

		if (!offerId) return;

		const saveClickUrl = `${getPublicUrl()}/api/company/offer/${offerId}`;

		try {
			await axios.put(saveClickUrl);
		} catch (error) {
			console.error('Error saving click:', error);
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new Company();
});